const Assets = {
  personSilhouetteImage: 'assets/images/avatars/profile.jpg',
  defaultPlaceImage: 'assets/images/default-place-image.svg',
  favicon: 'favicon.ico',
  logo: 'assets/images/logos/messagespring-logo.svg',
  messageText: 'assets/images/logos/messagespring-text-only.png',
  logoRev: 'assets/images/logos/messagespring-logo-rev.svg',
  banner: 'assets/images/logos/messagespring-banner.svg',
  bannerRev: 'assets/images/logos/messagespring-banner-rev.svg',
  registerSuccess: {
    headerImage: 'assets/images/registerSuccess/headerImage.svg',
  },
  redMailWithCircleBgIcon: 'assets/images/icons/ic-redMailWithCircleBg.svg',
  iconCSV: '/assets/images/tableMenu/ic-csv.svg',
  iconPDF: '/assets/images/tableMenu/ic-pdf.svg',
  iconMegaphone: '/assets/images/icons/ic-megaphone.svg',
  megaphoneBgIcon: '/assets/images/icons/megaphone-bg-icon.svg',
  iconVoucher: 'assets/images/icons/voucher.svg',
  iconVoucherBlack: 'assets/images/icons/voucher-black.svg',
  iconCheck: '/assets/images/tableMenu/ic-check.svg',
  deleteOutline: '/assets/images/tableMenu/delete-outline-24-px.svg',
  qrCode: '/assets/images/icons/qrcode-solid.svg',
  paymentMethodLogo: {
    Visa: '/assets/images/logos/visa.svg',
    JCB: '/assets/images/logos/jcb.svg',
    MasterCard: '/assets/images/logos/mastercard.svg',
    Discover: '/assets/images/logos/discover.svg',
    'American Express': '/assets/images/logos/amex.svg',
    PayPalAccount: '/assets/images/logos/paypal.svg',
  },
  notiType: {
    info: '/assets/images/notiType/info-24px.svg',
    booking: '/assets/images/notiType/group-9384.svg',
    event: '/assets/images/notiType/group-9381.svg',
    news: '/assets/images/notiType/library-books-24-px.svg',
    poll: '/assets/images/notiType/list-alt-24-px.svg',
    promotion: '/assets/images/notiType/card-giftcard-24-px.svg',
    raffle: '/assets/images/notiType/how-to-vote-24-px.svg',
    discount: '/assets/images/notiType/discount.svg',
    voucher: '/assets/images/notiType/voucher.svg',
  },
  notiPriority: {
    information: '/assets/images/notiPriority/notifications-none-24-px.svg',
    important: '/assets/images/notiPriority/notification-important-24-px.svg',
    urgent: '/assets/images/notiPriority/notifications-urgent.svg',
    emergency: '/assets/images/notiPriority/notifications-emergency.svg',
  },
  notiTypeInNotiCard: {
    info: '/assets/images/notiType/inNotiCard/general.svg',
    event: '/assets/images/notiType/inNotiCard/event.svg',
  },
  notiPreviewCard: {
    heart: '/assets/images/icons/ic-heart.png',
    calendar: '/assets/images/icons/ic-calendar.png',
    mapPin: '/assets/images/icons/ic-map-pin.png',
  },
  notiPriorityInNotiCard: {
    important:
      '/assets/images/notiPriority/inNotiCard/notification-important.svg',
    informational:
      '/assets/images/notiPriority/inNotiCard/notification-informational.svg',
    urgent: '/assets/images/notiPriority/inNotiCard/notification-urgent.svg',
    emergency:
      '/assets/images/notiPriority/inNotiCard/notification-emergency.svg',
  },
  notiTypeInPreview: {
    info: '/assets/images/notiType/inPreview/general.svg',
    event: '/assets/images/notiType/inPreview/event.svg',
  },
  notiPriorityInPreview: {
    important:
      '/assets/images/notiPriority/inPreview/notification-important.svg',
    informational:
      '/assets/images/notiPriority/inPreview/notification-informational.svg',
    urgent: '/assets/images/notiPriority/inPreview/notification-urgent.svg',
    emergency:
      '/assets/images/notiPriority/inPreview/notification-emergency.svg',
  },
  uploadIcon: 'assets/images/etc/upload.png',
  download: 'assets/images/etc/download.png',
  unsent: 'assets/images/etc/cancel-24-px-2.svg',
  tips: {
    alert: 'assets/images/media/info-24px@2x.png',
    doNotTranslate: 'assets/images/tips/ic-do-not-translate.svg',
    chrome: 'assets/images/tips/ic-chrome.png',
    grammarly: 'assets/images/tips/ic-grammarly.png',
  },
  event: {
    eventLocation: 'assets/images/event/event-location.svg',
    eventIcPdf: 'assets/images/event/ic-pdf.svg',
    eventIcCsv: 'assets/images/event/ic-csv.svg',
    eventIcDelete: 'assets/images/event/ic-delete.svg',
    eventIcEdit: 'assets/images/event/ic-edit.svg',
  },
  createNoti: {
    media: {
      photo: 'assets/images/media/add-photo-alternate-24-px.svg',
      pdf: 'assets/images/media/picture-as-pdf-24-px.svg',
      youtube: 'assets/images/media/video-library-24-px.svg',
      delete: 'assets/images/media/delete_forever-24px@2x.png',
      pdfThumbnail: 'assets/images/media/picture_as_pdf-success-24px@2x.png',
      icons: {
        photoActive: 'assets/images/media/icons/photoActive.png',
        pdfActive: 'assets/images/media/icons/pdfActive.png',
        videoActive: 'assets/images/media/icons/videoActive.png',
        photoInActive: 'assets/images/media/icons/photoInActive.png',
        pdfInActive: 'assets/images/media/icons/pdfInActive.png',
        videoInActive: 'assets/images/media/icons/videoInActive.png',
        closeImage: 'assets/images/icons/close.png',
      },
    },
  },
  profileInfo: {
    action: {
      makePublicIcon: 'assets/images/profileInfo/action/makePublicIcon.svg',
      makePrivateIcon: 'assets/images/profileInfo/action/makePrivateIcon.svg',
    },
  },
  manageBeacon: {
    beaconIcon: '/assets/images/icons/beacon_blue@2x.png',
    colors: {
      mint: '/assets/images/beacon.png',
      default: '/assets/images/beacon.png',
    },
  },
  notificationCard: {
    pdfIcon: 'assets/images/notification/pdf-icon.png',
  },
  qr: {
    background: 'assets/images/backgrounds/qr-background.png',
  },
  conversation: {
    chatListIcon: 'assets/images/conversations/chatListIcon.png',
    chatRoomIcon: 'assets/images/conversations/chatRoomIcon.png',
    chatIcon: 'assets/images/icons/ic-chat.png',
    previewDefault: 'assets/images/conversations/preview_default.png',
    msgSendIcon: 'assets/images/conversations/msgSendIcon.png',
    msgReadIcon: 'assets/images/conversations/msgReadIcon.png',
    msgFailIcon: 'assets/images/conversations/msgFailIcon.png',
  },
  dealAndPromotion: {
    voucherDefault: 'assets/images/dealPromotion/voucher_default.png',
    voucherWatermark: 'assets/images/dealPromotion/voucher_watermark.png',
    errorPermissionIcon: 'assets/images/voucherPermission.png',
    voucherIcon: 'assets/images/icons/voucherIcon.png',
    voucherTicket: 'assets/images/dealPromotion/voucher_ticket.png',
    banners: {
      category_1: 'assets/images/dealPromotion/banner/category_1.png',
      category_2: 'assets/images/dealPromotion/banner/category_2.png',
      category_3: 'assets/images/dealPromotion/banner/category_3.png',
      category_4: 'assets/images/dealPromotion/banner/category_4.png',
      category_5: 'assets/images/dealPromotion/banner/category_5.png',
    },
  },
  iconNotifyMe: 'assets/images/NotifyMe2.svg',
  redemption: {
    cancel: 'assets/images/cancel.svg',
    approved: 'assets/images/check_circle.svg',
  },
  filterIcon: {
    clearIcon: '/assets/images/icons/Cross@2x.png',
  },
  membershipCardIcon: {
    emptyMemberCard: 'assets/images/memberCard/member-card-placeholder.svg',
    addIcon: 'assets/images/icons/add-membership-card.png',
  },
  subscriber: {
    errorPermissionIcon: 'assets/images/subscriberPermission.png',
  },
  channels: {
    emailIcon: 'assets/images/icons/message.png',
    smsIcon: 'assets/images/icons/comments.png',
    emailIconBlack: 'assets/images/icons/ic-email.svg',
    smsIconBlack: 'assets/images/icons/ic-sms.svg',
    automateCallIcon: 'assets/images/icons/automate-call.svg',
    automateCallBlack: 'assets/images/icons/ic-automate-call.svg',
    automateCallDisable: 'assets/images/icons/ic-automate-call-disable.svg',
    socilaIconBlack: 'assets/images/icons/ic-social.svg',
  },
  nmName: 'assets/images/nm-name-change-stay-tuned.png',
  postIcon: {
    dark: 'assets/images/icons/postIconDark.png',
    white: 'assets/images/icons/postIconWhite.png',
    blue: 'assets/images/icons/postIconBlue.svg',
  },
  topicsIcon: 'assets/images/icons/topics.svg',
  subscrierWidgetIcon: 'assets/images/icons/ms-intro-create-group.svg',
  topicBtn: 'assets/images/topic-btn.png',
  hashtag: 'assets/images/icons/topicHashtag.svg',
  topicPageEmptyLogo: 'assets/images/empty-topic.png',
  twitterIcon:
    'assets/images/social-integrations/social-media-provider-twitter.svg',
  linkedinIcon:
    'assets/images/social-integrations/social-media-provider-linkedin.png',
  facebookIcon:
    'assets/images/social-integrations/social-media-provider-facebook.svg',
  instagramIcon:
    'assets/images/social-integrations/social-media-provider-instagram.svg',
  socialMediaInteractionIcons: {
    likesIcon: 'assets/images/icons/like-heart.svg',
    commentsIcon: 'assets/images/icons/comments.svg',
  },
  dashboard: {
    eyeIcon: 'assets/images/icons/dashboard/eye.svg',
    timelineOutline: 'assets/images/icons/dashboard/timeline-outline.svg',
    openedIcon: 'assets/images/icons/dashboard/openedIcon.svg',
    deliveryIcon: 'assets/images/icons/dashboard/deliveryIcon.svg',
    inappropriateIcon: 'assets/images/icons/dashboard/inappropriateIcon.svg',
    likedIcon: 'assets/images/icons/dashboard/likedIcon.svg',
  },
  copyIcon: 'assets/images/icons/ic-copy.svg',
  infoIcon: 'assets/images/icons/ic-info.svg',
  badcontactIcon: 'assets/images/icons/ic-badcontact.svg',
  autoFixHigh: 'assets/images/icons/auto-fix-high.svg',
  questionAnswer: 'assets/images/icons/question-answer.svg',
  screenSearchDesktop: 'assets/images/icons/screen-search-desktop.svg',
  arrowCircleIcon: 'assets/images/icons/ic-arrow.svg',
  copyDisableIcon: 'assets/images/icons/ic-info-disabled.svg',
  conversationIcon: 'assets/images/icons/ic-conversation.svg',
  accessibilityIcon: 'assets/images/icons/ic-accessibility.svg',
  barChartIcon: 'assets/images/icons/ic-bar-chart.svg',
  channelsIcon: 'assets/images/icons/ic-channels.svg',
  groupsIcon: 'assets/images/icons/ic-groups.svg',
  userPlusIcon: 'assets/images/icons/ic-user-plus.svg',
  info_2_Icon: 'assets/images/icons/ic-info-2.svg',
  questionIcon: 'assets/images/icons/ic-question.svg',
  checkCorrect: 'assets/images/icons/ic-check-circle-correct.svg',
  gallery: 'assets/images/icons/gallery-icon.svg',
  emergency: 'assets/images/icons/ic-emergency.svg',
  billingAddress: {
    name: 'assets/images/icons/ic-person-bg-grey.svg',
    address: 'assets/images/icons/ic-map-bg-grey.svg',
    phoneIcon: 'assets/images/icons/ic-phone-bg-grey.svg',
  },
  lockeIcon: 'assets/images/icons/ic-lock.svg',
  usageSummary: 'assets/images/icons/ic-usage-summary.svg',
  carendar: 'assets/images/icons/ic-calendar-filter.svg',
  carendarWhite: 'assets/images/icons/ic-calendar-filter-white.svg',
  usageHistory: 'assets/images/icons/ic-usage-history.svg',
  bellIcon: 'assets/images/icons/bell-icon.svg',
  cookieIcon: 'assets/images/icons/cookie.svg',
  termIcon: 'assets/images/icons/term-icon.svg',
  privacyIcon: 'assets/images/icons/privacy-icon.svg',
  googleBard: {
    fill: '/assets/images/icons/ai/google-bard-icon.svg',
    thinking:
      'https://www.gstatic.com/lamda/images/sparkle_thinking_v2_e272afd4f8d4bbd25efe.gif',
    resting:
      'https://www.gstatic.com/lamda/images/sparkle_resting_v2_1ff6f6a71f2d298b1a31.gif',
  },
  helpIcon: 'assets/images/icons/help-icon.svg',
  AILoading: '/assets/images/icons/ai/loading.gif',
  imageDefault: '/assets/images/imageDefault.svg',
  groupv4EmptyIcon: '/assets/images/groupEmpty.svg',
  groupv4EmptySubscriberIcon: 'assets/images/groupv4EmptySubscriber.svg',
  confirmEmailSuccess: 'assets/images/ConfirmEmailSuccess.svg',
  confirmEmailError: 'assets/images/ConfirmEmailError.svg',
  noFavoritesIcon: 'assets/images/icons/no-favorites.svg',
  lineIcon: 'assets/images/icons/LINE_Brand_icon.png',
}

export default Assets
